import React from 'react';

const SVG = ({ width = '12px', height = '12px', className = '', viewBox = '0 0 8 12', color = '#FD3A52' }) => (
  <svg height={height} width={width} viewBox={viewBox} className={className}>
    <g id='workflow' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd' opacity='0.769999981'>
      <g id='Page-4.3' transform='translate(-448.000000, -313.000000)'>
        <g id='Group-45' transform='translate(255.000000, 204.000000)'>
          <g id='Group-5'>
            <g id='Group-20' transform='translate(15.000000, 76.000000)'>
              <g id='Group-22' transform='translate(142.000000, 32.000000)'>
                <g id='Group-23'>
                  <g id='delete' transform='translate(33.000000, 0.000000)'>
                    <g id='delete_forever-24px-(1)'>
                      <polygon id='Path' points='0 0 13 0 13 13 0 13'></polygon>
                      <path
                        d='M3.60504202,10.3660131 C3.60504202,10.9735294 4.09663866,11.4705882 4.69747899,11.4705882 L9.06722689,11.4705882 C9.66806723,11.4705882 10.1596639,10.9735294 10.1596639,10.3660131 L10.1596639,3.73856209 L3.60504202,3.73856209 L3.60504202,10.3660131 Z M4.9487395,6.43372549 L5.71890756,5.655 L6.88235294,6.82584967 L8.04033613,5.655 L8.8105042,6.43372549 L7.65252101,7.60457516 L8.8105042,8.77542484 L8.04033613,9.55415033 L6.88235294,8.38330065 L5.72436975,9.55415033 L4.95420168,8.77542484 L6.11218487,7.60457516 L4.9487395,6.43372549 Z M8.79411765,2.08169935 L8.24789916,1.52941176 L5.51680672,1.52941176 L4.97058824,2.08169935 L3.05882353,2.08169935 L3.05882353,3.18627451 L10.7058824,3.18627451 L10.7058824,2.08169935 L8.79411765,2.08169935 Z'
                        id='Shape'
                        fill={color}
                        fillRule='nonzero'
                      ></path>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default SVG;
